import React, { useState } from "react";

const TableOfContents = ({
    items,
    eyebrow = "Agenda / Table of contents",
    title = "Table of contents",
    titleId = "table-of-contents-title",
}) => {
    const [openItemIds, setOpenItemIds] = useState(() =>
        items.filter((item) => item.children.length > 0).map((item) => item.id),
    );

    const toggleItem = (itemId) => {
        setOpenItemIds((currentIds) =>
            currentIds.includes(itemId)
                ? currentIds.filter((id) => id !== itemId)
                : [...currentIds, itemId],
        );
    };

    const scrollToContent = (event, id) => {
        const target = document.getElementById(id);

        if (!target) {
            return;
        }

        event.preventDefault();
        target.scrollIntoView({ behavior: "smooth", block: "start" });
        window.history.replaceState(null, "", `#${id}`);
    };

    if (!items?.length) {
        return null;
    }

    return (
        <nav className="table-of-contents" aria-labelledby={titleId}>
            <div className="table-of-contents__eyebrow">{eyebrow}</div>
            <div className="table-of-contents__box">
                <h2 className="table-of-contents__title" id={titleId}>
                    {title}
                </h2>
                <ol className="table-of-contents__list">
                    {items.map((item, index) => (
                        <li className="table-of-contents__item" key={item.id}>
                            {item.children.length > 0 ? (
                                <button
                                    className="table-of-contents__link"
                                    type="button"
                                    aria-expanded={openItemIds.includes(
                                        item.id,
                                    )}
                                    aria-controls={`${item.id}-subtitles`}
                                    onClick={() => toggleItem(item.id)}
                                >
                                    <span className="table-of-contents__number">
                                        {String(index + 1).padStart(2, "0")}
                                    </span>
                                    <span className="table-of-contents__label">
                                        {item.label}
                                    </span>
                                </button>
                            ) : (
                                <a
                                    className="table-of-contents__link"
                                    href={`#${item.id}`}
                                    onClick={(event) =>
                                        scrollToContent(event, item.id)
                                    }
                                >
                                    <span className="table-of-contents__number">
                                        {String(index + 1).padStart(2, "0")}
                                    </span>
                                    <span className="table-of-contents__label">
                                        {item.label}
                                    </span>
                                </a>
                            )}
                            {item.children.length > 0 && (
                                <div
                                    className={`table-of-contents__children-wrapper ${
                                        openItemIds.includes(item.id)
                                            ? "-open"
                                            : ""
                                    }`}
                                    id={`${item.id}-subtitles`}
                                    aria-hidden={!openItemIds.includes(item.id)}
                                >
                                    <div className="table-of-contents__children-inner">
                                        <ul className="table-of-contents__children">
                                            {item.children.map((child) => (
                                                <li key={child.id}>
                                                    <a
                                                        href={`#${child.id}`}
                                                        tabIndex={
                                                            openItemIds.includes(
                                                                item.id,
                                                            )
                                                                ? 0
                                                                : -1
                                                        }
                                                        onClick={(event) =>
                                                            scrollToContent(
                                                                event,
                                                                child.id,
                                                            )
                                                        }
                                                    >
                                                        {child.label}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            )}
                        </li>
                    ))}
                </ol>
            </div>
        </nav>
    );
};

export default TableOfContents;
